"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketClient = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const __1 = require("..");
const anchor_1 = require("@project-serum/anchor");
const matching_1 = require("../utils/matching");
class MarketClient {
    constructor(ctx, publicKey, tokenMint, pda, data) {
        this.ctx = ctx;
        this.publicKey = publicKey;
        this.tokenMint = tokenMint;
        this.data = data;
        this.pda = pda;
        this.escrowFetcher = new __1.EscrowFetcher(ctx.connection, pda);
    }
    static getMarket(ctx, configId, marketId, tokenMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId, marketId);
            const marketAccount = pda.getMarketPDA(tokenMint).key;
            const marketStateData = (yield ctx.program.account.marketState.fetch(marketAccount));
            return new MarketClient(ctx, marketAccount, tokenMint, pda, marketStateData);
        });
    }
    setTradeConfigAuthority(deployerPubkey, newTradeConfigAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setTradeConfigAuthorityIx({
                marketAccount: this.publicKey,
                deployerPubkey: deployerPubkey,
                newTradeConfigAuthority,
            })).toTx();
            return tx;
        });
    }
    setAmlPolicyAuthority(deployerPubkey, newAmlPolicyAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setAmlPolicyAuthorityIx({
                marketAccount: this.publicKey,
                deployerPubkey: deployerPubkey,
                newAmlPolicyAuthority,
            })).toTx();
            return tx;
        });
    }
    addArbitratorCert(tradeConfigAuthority, arbitratorAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            let arbitratorCertPDA = this.pda.getArbitratorCertPDA(arbitratorAuthority, this.tokenMint);
            const tx = (yield this.ctx.ixs.addArbitratorCertIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                arbitratorAuthority,
                arbitratorCert: arbitratorCertPDA.key,
                arbitratorCertBump: arbitratorCertPDA.bump,
            })).toTx();
            return tx;
        });
    }
    addTokenMetadata(tradeConfigAuthority, quota30Days, quota24Hours) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.addTokenMetadataIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                quota30Days,
                quota24Hours,
            })).toTx();
            return tx;
        });
    }
    addTokenOracleMetadata(tradeConfigAuthority, renecOraclePubkey, quota30Days, quota24Hours) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.addTokenOracleMetadataIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                quota30Days,
                quota24Hours,
                renecOraclePubkey,
            })).toTx();
            return tx;
        });
    }
    setRenecRate(tradeConfigAuthority, renecRate) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setRenecRateIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                renecRate,
            })).toTx();
            return tx;
        });
    }
    setUsdRate(tradeConfigAuthority, usdRate) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setUsdRateIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                usdRate,
            })).toTx();
            return tx;
        });
    }
    setMinmumOfferSize(tradeConfigAuthority, minimumOfferSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setMinimumOfferSize({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                minimumOfferSize,
            })).toTx();
            return tx;
        });
    }
    removeArbitratorCert(tradeConfigAuthority, arbitratorAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            let arbitratorCertPDA = this.pda.getArbitratorCertPDA(arbitratorAuthority, this.tokenMint);
            const tx = (yield this.ctx.ixs.removeArbitratorCertIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority,
                arbitratorAuthority,
                arbitratorCert: arbitratorCertPDA.key,
            })).toTx();
            return tx;
        });
    }
    updateMarketState(tradeConfigAuthority, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const { arbitratorCommission = null, bondSize = null, paymentDuration = null, treasuryPubkey = null, treasuryShare = null, cancelPenaltyRate = null, limitActiveBondlessTrade = null, } = option;
            const tx = (yield this.ctx.ixs.updateMarketIx({
                marketAccount: this.publicKey,
                tradeConfigAuthority: tradeConfigAuthority,
                treasuryPubkey,
                bondSize,
                arbitratorCommission,
                treasuryShare,
                paymentDuration,
                cancelPenaltyRate,
                limitActiveBondlessTrade,
            })).toTx();
            return tx;
        });
    }
    setKycCert(amlPolicyAuthority, user, level) {
        return __awaiter(this, void 0, void 0, function* () {
            const kycCertPDA = this.pda.getKycCertPDA(user, this.tokenMint);
            const accountInfo = yield this.ctx.connection.getAccountInfo(kycCertPDA.key);
            // If the account doesn't exist, we need to initialize it
            let prependIxs = [];
            if (accountInfo == null) {
                const initKycCertIx = (yield this.ctx.ixs.initKycCertIx({
                    marketAccount: this.publicKey,
                    caller: amlPolicyAuthority,
                    user,
                    tokenMint: this.data.tokenMint,
                    kycCertPubkey: kycCertPDA.key,
                    kycCertBump: kycCertPDA.bump,
                })).ix;
                if (!initKycCertIx) {
                    throw new Error("Fail to get the initialize kyc cert instruction");
                }
                prependIxs.push(initKycCertIx);
            }
            // create the setKycCertIx transaction
            const tx = (yield this.ctx.ixs.setKycCertIx({
                marketAccount: this.publicKey,
                amlPolicyAuthority,
                user,
                tokenMint: this.data.tokenMint,
                kycCertPubkey: kycCertPDA.key,
                level,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return tx;
        });
    }
    getKycCert(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const kycCertPDA = this.pda.getKycCertPDA(user, this.tokenMint);
            const kycCertData = (yield this.ctx.program.account.kycCert.fetch(kycCertPDA.key));
            return kycCertData;
        });
    }
    isArbitrator(arbitratorAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            let arbitratorCertPDA = this.pda.getArbitratorCertPDA(arbitratorAuthority, this.tokenMint);
            try {
                yield this.ctx.program.account.arbitratorCert.fetch(arbitratorCertPDA.key);
                return true;
            }
            catch (_a) {
                return false;
            }
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const escrowConfigData = (yield this.ctx.program.account.marketState.fetch(this.publicKey));
            this.data = escrowConfigData;
            return this;
        });
    }
    getOffersQuotesMatchingEngine(totalTradeAmount, bondType) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint } = this.data;
            let offersAccountData = yield this.escrowFetcher.getOffersByStatus(__1.OfferState.Awaiting, __1.TradeSide.Sell);
            offersAccountData = offersAccountData.filter((item) => item.tokenMint.equals(tokenMint));
            if (bondType) {
                offersAccountData = offersAccountData.filter((item) => JSON.stringify(item.bondType) === JSON.stringify(bondType));
            }
            const matchedOffers = (0, matching_1.matchOffers)(offersAccountData, totalTradeAmount);
            if (!matchedOffers.length) {
                return null;
            }
            // //
            const configAccount = this.pda.getConfigPDA().key;
            let currentTradeId = (yield this.ctx.program.account.escrowConfig.fetch(configAccount)).currentTradeId;
            const bumps = [];
            const remainingAccounts = [];
            const tradeIds = [];
            const tradeAmounts = [];
            let remainAmount = new anchor_1.BN(totalTradeAmount);
            let tradeAmount;
            for (const offerData of matchedOffers) {
                if (remainAmount.eq(new anchor_1.BN(0))) {
                    break;
                }
                //
                if (offerData.availableAmount.gte(remainAmount)) {
                    tradeAmount = remainAmount;
                    remainAmount = new anchor_1.BN(0);
                }
                else {
                    tradeAmount = offerData.availableAmount;
                    remainAmount = remainAmount.sub(tradeAmount);
                }
                const tradePDA = this.pda.getTradePDA(currentTradeId);
                const accounts = [offerData.pubkey, tradePDA.key];
                const accountMeta = accounts.map((pubkey) => {
                    return {
                        isSigner: false,
                        isWritable: true,
                        pubkey: pubkey,
                    };
                });
                remainingAccounts.push(...accountMeta);
                bumps.push(tradePDA.bump);
                tradeIds.push(new anchor_1.BN(currentTradeId));
                tradeAmounts.push(new anchor_1.BN(tradeAmount));
                currentTradeId = currentTradeId.add(new anchor_1.BN(1));
            }
            return {
                offerQuantity: tradeIds.length,
                tradeQuantity: tradeIds.length,
                transactionQuantity: Math.ceil(tradeIds.length / matching_1.MAX_TRADE_PER_TRANSACTION),
                remainingAccounts: remainingAccounts,
                tradeIds: tradeIds,
                tradeAmounts: tradeAmounts,
                bumps: bumps,
            };
        });
    }
    buildMatchingEngineTransaction(user, tradeAmount, matchingData, useBondless) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint } = this.data;
            const configAccount = this.pda.getConfigPDA().key;
            const marketAccount = this.pda.getMarketPDA(tokenMint).key;
            const marketTokenVault = this.pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeVault = this.pda.getMarketNativeVaultPDA(tokenMint).key;
            //
            let prependIxs = [];
            // Get or create joiner token acccount
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, user, tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, user), { address: userTokenAccount } = _a, instruction = __rest(_a, ["address"]);
            const userKycCertPda = this.pda.getKycCertPDA(user, tokenMint);
            const accountInfo = yield this.ctx.connection.getAccountInfo(userKycCertPda.key);
            if (accountInfo == null) {
                const initKycCertIx = (yield this.ctx.ixs.initKycCertIx({
                    marketAccount: marketAccount,
                    caller: user,
                    user: user,
                    tokenMint: this.data.tokenMint,
                    kycCertPubkey: userKycCertPda.key,
                    kycCertBump: userKycCertPda.bump,
                })).ix;
                if (!initKycCertIx) {
                    throw new Error("Fail to get the initialize kyc cert instruction");
                }
                prependIxs.push(initKycCertIx);
            }
            prependIxs.push(instruction);
            const tx = (yield this.ctx.ixs.matchingEngineIx({
                configAccount: configAccount,
                marketAccount: marketAccount,
                marketTokenVault: marketTokenVault,
                marketNativeVault: marketNativeVault,
                kycCert: userKycCertPda.key,
                user,
                userTokenAccount,
                useBondless,
                totalTradeAmount: tradeAmount,
                offerQuantity: matchingData.offerQuantity,
                tradeIds: matchingData.tradeIds,
                bumps: matchingData.bumps,
                remainingAccounts: matchingData.remainingAccounts,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return { tx: tx, ids: matchingData.tradeIds };
        });
    }
    matchingEngine(user, totalTradeAmount, offerQuotes, useBondless) {
        return __awaiter(this, void 0, void 0, function* () {
            // validate offer quotes valid
            (0, matching_1.validateOfferQuotes)(offerQuotes);
            // split quotes into each transaction
            const txs = [];
            const idsByTx = [];
            const remainAccountsArray = offerQuotes.remainingAccounts;
            const tradeIdsArray = offerQuotes.tradeIds;
            const bumpsArray = offerQuotes.bumps;
            for (let i = 0; i < offerQuotes.transactionQuantity; i++) {
                const startSliceRemain = i * matching_1.REQUIRE_ACCOUNT_PER_TRADE * matching_1.MAX_TRADE_PER_TRANSACTION;
                const endSliceRemainAccount = startSliceRemain + matching_1.REQUIRE_ACCOUNT_PER_TRADE * matching_1.MAX_TRADE_PER_TRANSACTION;
                const remainingAccounts = remainAccountsArray.slice(startSliceRemain, endSliceRemainAccount);
                const startSliceTradeId = i * matching_1.MAX_TRADE_PER_TRANSACTION;
                const endSliceTradeId = startSliceTradeId + matching_1.MAX_TRADE_PER_TRANSACTION;
                const tradeIds = tradeIdsArray.slice(startSliceTradeId, endSliceTradeId);
                const startSliceBump = i * matching_1.REQUIRE_BUMP_PER_TRADE * matching_1.MAX_TRADE_PER_TRANSACTION;
                const endSliceBump = startSliceBump + matching_1.REQUIRE_BUMP_PER_TRADE * matching_1.MAX_TRADE_PER_TRANSACTION;
                const bumps = bumpsArray.slice(startSliceBump, endSliceBump);
                const matchingData = {
                    offerQuantity: tradeIds.length,
                    tradeIds: tradeIds,
                    bumps: bumps,
                    remainingAccounts: remainingAccounts,
                };
                const { tx: tx, ids: ids } = yield this.buildMatchingEngineTransaction(user, totalTradeAmount, matchingData, useBondless);
                txs.push(tx);
                idsByTx.push(ids);
            }
            return { txs, ids: idsByTx };
        });
    }
    requestCreateTrade(offerId, user, tradeAmount, useBondless) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint } = this.data;
            const configAccount = this.pda.getConfigPDA().key;
            const marketAccount = this.pda.getMarketPDA(tokenMint).key;
            const marketTokenVault = this.pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeVault = this.pda.getMarketNativeVaultPDA(tokenMint).key;
            const offerAccount = this.pda.getOfferPDA(offerId);
            const currentTradeId = (yield this.ctx.program.account.escrowConfig.fetch(configAccount)).currentTradeId;
            const tradePDA = this.pda.getTradePDA(currentTradeId);
            const remainingAccounts = [
                {
                    isSigner: false,
                    isWritable: true,
                    pubkey: offerAccount.key,
                },
                {
                    isSigner: false,
                    isWritable: true,
                    pubkey: tradePDA.key,
                },
            ];
            //
            let prependIxs = [];
            // Get or create joiner token acccount
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, user, tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, user), { address: userTokenAccount } = _a, instruction = __rest(_a, ["address"]);
            const userKycCertPda = this.pda.getKycCertPDA(user, tokenMint);
            const accountInfo = yield this.ctx.connection.getAccountInfo(userKycCertPda.key);
            if (accountInfo == null) {
                const initKycCertIx = (yield this.ctx.ixs.initKycCertIx({
                    marketAccount: marketAccount,
                    caller: user,
                    user: user,
                    tokenMint: this.data.tokenMint,
                    kycCertPubkey: userKycCertPda.key,
                    kycCertBump: userKycCertPda.bump,
                })).ix;
                if (!initKycCertIx) {
                    throw new Error("Fail to get the initialize kyc cert instruction");
                }
                prependIxs.push(initKycCertIx);
            }
            prependIxs.push(instruction);
            const tx = (yield this.ctx.ixs.matchingEngineIx({
                configAccount: configAccount,
                marketAccount: marketAccount,
                marketTokenVault: marketTokenVault,
                marketNativeVault: marketNativeVault,
                kycCert: userKycCertPda.key,
                user,
                userTokenAccount,
                useBondless,
                totalTradeAmount: tradeAmount,
                offerQuantity: 1,
                tradeIds: [currentTradeId],
                bumps: [tradePDA.bump],
                remainingAccounts: remainingAccounts,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return { tx: tx, id: currentTradeId };
        });
    }
}
exports.MarketClient = MarketClient;
